import React from "react";
import Container from "../components/container";
import Layout from "../components/layouts/main-layout";

const ImpressumPage = () => {
  return (
    <Layout>
        <Container>
        <h1>Impressum</h1>
        <h2>Angaben gemäß § 5 TMG:</h2>
        <p>
          Tidens Surfhuus<br />
          Hendrik Wolff
          <br />
          Am Wall 5<br />
          26465 Langeoog
        </p>

        <h3>Kontakt:</h3>

        <p>
          Telefon: +49 160 99892384
          <br />
          E-Mail: info@tidens-surfhuus.de
        </p>

        <h2>Umsatzsteuer:</h2>

        <p>
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
          <br />
          DE460288299
        </p>

        <h3>Redaktionell Verantwortlicher:</h3>

        <p>
          Hendrik Wolff
          <br />
          Am Wall 5<br />
          26465 Langeoog
        </p>

        <h3>
          Verbraucherstreitbeilegung / Universalschlichtungsstelle
        </h3> 

        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h3>Quellenangaben</h3>
        <p><a href="https://github.com/feathericons/feather/" rel="noreferrer" target="_blank">Feather Icons (MIT License (MIT))</a><br />
        Placeholder: Image by <a href="https://www.freepik.com/free-vector/modern-pack-silhouette-avatars_1292965.htm#query=placeholder&position=3&from_view=keyword&track=sph&uuid=4d6492f5-e315-4445-9520-283daeb51496" rel="noreferrer" target="_blank">https://www.freepik.com/</a><br />
        Weitere Fotos: Katharina Thiesen
        </p>

        <h3>Haftung für Inhalte</h3>

        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>

        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen werden wir diese Inhalte
          umgehend entfernen.
        </p>

        <h3>Haftung für Links</h3>

        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
        </p>

        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
          ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links
          umgehend entfernen.
        </p>

        <h3>Urheberrecht</h3>

        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
          sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>

        <p>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
          wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
          Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf
          eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
          entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
          werden wir derartige Inhalte umgehend entfernen.
        </p>
        </Container>
    </Layout>
  );
};

export default ImpressumPage;
